<!-- Top bar -->
<mat-toolbar class="topBar" style="justify-content: space-between;">
  <!-- Left Side Content -->
  <div style="display: flex; align-items: center; gap: 20px;">
    <!-- Back Button -->
    <button mat-mini-fab
            class="example-icon"
            type="button"
            aria-label="Back"
            [matTooltip]="partOfDraftTrip != -1 ? 'Back to Draft' : setIndex == -1 || previousScreen == 'delivery' ? 'Back to Delivery' : previousScreen == 'deliveries_list' ? 'Back to Deliveries' : 'Back to Home'"
            matTooltipPosition="below"
            (click)="handleExit(partOfDraftTrip != -1 ? 'draft' : setIndex == -1 || previousScreen == 'delivery' ? 'delivery' : previousScreen == 'deliveries_list' ? 'deliveries_list' : 'menu')">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <!-- Home Button -->
    <button mat-mini-fab
            class="example-icon"
            type="button"
            matTooltip="Back to Home"
            matTooltipPosition="below"
            (click)="handleExit('menu')">
      <mat-icon>home</mat-icon>
    </button>

    
  </div>

  <!-- Title -->
  <span *ngIf="setIndex == -1" style="color: white;">Editing Set</span>
  <span *ngIf="setIndex != -1" style="color: white;">Daily Fishing</span>

  <!-- Right Side Buttons -->
  <div style="display: flex; align-items: center; gap: 20px;">

     <!-- Delete Button -->
  <button *ngIf="!isReadOnly && partOfDraftTrip == -1"
      mat-mini-fab
      class="example-icon"
      matTooltip="Delete"
      matTooltipPosition="below"
      (click)="confirmDelete()">
    <mat-icon>delete</mat-icon>
  </button>

    <!-- Set Errors -->
  <button *ngIf="!isReadOnly"
        mat-mini-fab
        [matBadge]="errorNumber" [matBadgeHidden]="errorNumber == 0" matBadgePosition="above before"
        class="bottom-toolbar-button"
        type="button"
        aria-label="Example icon button with a plus one icon"
        matTooltip="Errors"
        matTooltipPosition="above"
        [disabled]="disableAdd || (setDetailForm.valid && stringNum.valid)"
        (click)="openErrorDialog()">
      <mat-icon>
      priority_high
      </mat-icon>
  </button>

  </div>

</mat-toolbar>

<br>


<!-- The form for all of the input fields -->
<form [formGroup]="setDetailForm">
  <div class="container" style="max-width: none;">
    <div class="row">
      <div class="col">
        <div class="row">
          <mat-form-field style="font-weight: bold;">
            <mat-label>Date </mat-label>
            <input matInput readonly formControlName="fishingDate" (click)="editDateTime()" required>

            <!-- Fill haul with current location -->
            <button *ngIf="!isReadOnly"
                    mat-mini-fab
                    matSuffix
                    class="blue-icon-button"
                    style="margin-right: 8px; color: white; background-color: #005d87"
                    type="button"
                    matTooltip="Fill Date"
                    matTooltipPosition="below"
                    (click)="fillSetDateLocation(true)">
              <mat-icon>
                calendar_month
              </mat-icon>
            </button>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-7">
          <mat-form-field style="width: 100%;">
            <mat-label>Gear</mat-label>
            <mat-select formControlName="gear" required>
              <mat-option *ngFor="let gear of gearOptions" [value]="gear">{{gear}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-5" *ngIf="setDetailForm.get('gear')?.value === 'Deep Set Buoy Gear'">
          <mat-form-field style="width: 100%;">
            <mat-label>DSBG Type</mat-label>
            <mat-select formControlName="dsbgType"   [compareWith]="compareDSBGtype" required>
              <mat-option *ngFor="let sub of gearSubtypes" [value]="sub">{{sub.name}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-6" *ngIf="setDetailForm.get('gear')?.value === 'Deep Set Buoy Gear'">
          <mat-form-field style="width: 100%;">
            <mat-label>Total # of Buoys</mat-label>
            <input matInput type="number" formControlName="numBuoys" oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');">
          </mat-form-field>
        </div>
        <div class="col-6" *ngIf="setDetailForm.get('gear')?.value === 'Deep Set Buoy Gear'">
          <mat-form-field style="width: 100%;">
            <mat-label>Total # of Hooks</mat-label>
            <input matInput type="number" formControlName="numHooks" oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');">
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="row">
            <mat-form-field>
              <mat-label>Fishing Mode</mat-label>
              <mat-select formControlName="fishingMode" required>
                <mat-option value="Fish">
                  Fishing
                </mat-option>
                <mat-option value="Port">
                  In Port
                </mat-option>
                <mat-option value="Tran">
                  Transit
                </mat-option>
              </mat-select>
              <mat-error *ngIf="setDetailForm.invalid"></mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="row">
            <mat-form-field>
              <mat-label>Hours Fished </mat-label>
              <input matInput type="text" inputmode="decimal" formControlName="hoursFished" oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" required>
              <mat-error *ngIf="setDetailForm.get('hoursFished')!.hasError('min')">{{hoursFishedErrorMessage}}</mat-error>
              <mat-error *ngIf="setDetailForm.get('hoursFished')!.hasError('max')">Hours Fished cannot be more than 24</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="row">
            <mat-form-field>
              <mat-label>Latitude</mat-label>
              <input matInput readonly type="tel" formControlName="lat" (click)="openCoordinateDialog('lat')" required>

              <!-- Fill haul with current location -->
              <button  *ngIf="!isReadOnly"
                      mat-mini-fab
                      matSuffix
                      class="blue-icon-button"
                      style="margin-right: 8px; color: white; background-color: #005d87"
                      type="button"
                      matTooltip="Fill Haul Location"
                      matTooltipPosition="below"
                      (click)="fillSetDateLocation(false)">
                <mat-icon>
                  pin_drop
                </mat-icon>
              </button>
            </mat-form-field>
          </div>
        </div>

        <div class="col">
          <div class="row">
            <mat-form-field>
              <mat-label>Longitude</mat-label>
              <input readonly matInput input="tel" formControlName="lon" (click)="openCoordinateDialog('lon')" required>
            </mat-form-field>
          </div>
        </div>
      </div>


      <!-- Aircraft Used (for Harpoon) -->
      <div style="margin-bottom: 16px; margin-top: 16px;" *ngIf="setDetailForm.get('gear')?.value === 'Harpoon'">
        <mat-label style="font-size: 1.15rem;">Aircraft Used?</mat-label>
        <mat-radio-group formControlName="aircraftUsed" aria-label="Aircraft Used?" class="custom-radio-group">
          <mat-radio-button [value]="true">Yes</mat-radio-button>
          <mat-radio-button [value]="false">No</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>


  <!-- Catch -->
  <div class="row" style="padding-top: 10px;">
    <mat-toolbar class="mat-toolbar-section">
      <span>Catch</span>
      <span class="spacer"></span>

      <!-- Add a new catch -->
      <button *ngIf="!isReadOnly"
              mat-mini-fab
              class="blue-icon-button"
              type="button"
              aria-label="Example icon-button with share icon"
              matTooltip="Add New Catch"
              matTooltipPosition="below"
              (click)="openCatchDialog(fishingEvent.catchItems.length)">
        <mat-icon>
          add
        </mat-icon>
      </button>
    </mat-toolbar>
  </div>

  <!-- Catch data -->
  <div class="row">
    <table mat-table [dataSource]="fishingEvent?.catchItems ?? []">

      <ng-container matColumnDef="Species">
        <tr>
          <th mat-header-cell
              *matHeaderCellDef
              style="text-align: left;">
            Species
          </th>
          <td mat-cell
              *matCellDef="let item">
            {{item.species.name}}
          </td>
        </tr>
      </ng-container>

      <ng-container matColumnDef="RetainedCount">
        <tr>
          <th mat-header-cell
              *matHeaderCellDef>
            Count
          </th>
          <td mat-cell
              *matCellDef="let item"
              style="text-align:center">
            {{item.retainedCount ?? '-'}}
          </td>
        </tr>
      </ng-container>

      <ng-container matColumnDef="RetainedWeight">
        <tr>
          <th mat-header-cell
              *matHeaderCellDef
              style="border-right: 1px solid black;">
            Avg Weight
          </th>
          <td mat-cell
              *matCellDef="let item"
              style="text-align: center; border-right: 1px solid black;">
            {{ item.retainedWeight ?? '-'}}
          </td>
        </tr>
      </ng-container>

      <ng-container matColumnDef="ReleasedCount">
        <tr>
          <th mat-header-cell
              *matHeaderCellDef>
            Count
          </th>
          <td mat-cell
              *matCellDef="let item"
              style="text-align: center;">
            {{item.releasedCount ?? '-'}}
          </td>
        </tr>
      </ng-container>

      <ng-container matColumnDef="ReleasedWeight">
        <tr>
          <th mat-header-cell
              *matHeaderCellDef>
            Avg Weight
          </th>
          <td mat-cell
              *matCellDef="let item"
              style="text-align: center;">
            {{ item.releasedWeight ?? '-'}}
          </td>
        </tr>
      </ng-container>

      <ng-container matColumnDef="Filler">
        <tr>
          <th mat-header-cell
              *matHeaderCellDef>

          </th>
        </tr>
      </ng-container>


      <ng-container matColumnDef="Retained">
        <tr>
          <th mat-header-cell
              *matHeaderCellDef
              colspan="2"
              style="border-right: 1px solid black;">
            Retained
          </th>
        </tr>
      </ng-container>

      <ng-container matColumnDef="Released">
        <tr>
          <th mat-header-cell
              *matHeaderCellDef
              colspan="2">
            Released
          </th>
        </tr>
      </ng-container>


      <tr mat-header-row
          *matHeaderRowDef="['Filler', 'Retained', 'Released']"
          class="catch-first-header">
      </tr>

      <tr mat-header-row
          *matHeaderRowDef="catchTableHarpoonColumns"
          class="catch-second-header">
      </tr>

      <tr mat-row
          (click)="openCatchDialog(index)"
          *matRowDef="let row; columns: catchTableHarpoonColumns; let index=index;">
      </tr>
    </table>
  </div>

  <!-- Comments -->
  <div class="row" style="padding-top: 30px;">
    <mat-toolbar class="mat-toolbar-section">
      <span>Comments</span>
    </mat-toolbar>
  </div>

  <div class="row">
    <mat-form-field appearance="fill">
      <mat-label>Additional Comments</mat-label>
      <textarea matInput rows="9" formControlName="comments"></textarea>
    </mat-form-field>
  </div>

  <br>
  <br>
  <br>
  <br>
  <br>

  </div>
</form>

<!-- Bottom bar -->
<mat-toolbar class="toolbarNav" style="background-color: #004165; padding-left: 10px; padding-right: 10px;">

  <div style="flex-grow: 1; display: flex; justify-content: space-evenly;">
 <!-- Go to Previous Set -->
 <button *ngIf="!isReadOnly && partOfDraftTrip == -1"
 mat-fab
 class="bottom-toolbar-button"
 type="button"
 aria-label="Example icon button with a plus one icon"
 matTooltip="Previous Set"
 matTooltipPosition="above"
 [disabled]="setIndex == -1"
 (click)="previousSet()">
<mat-icon>
arrow_back
</mat-icon>
</button>

<!-- Add New Set -->
<button *ngIf="!isReadOnly && partOfDraftTrip == -1"
 mat-fab
 class="bottom-toolbar-button"
 type="button"
 aria-label="Example icon button with a plus one icon"
 matTooltip="Add Set"
 matTooltipPosition="above"
 [disabled]="setIndex == -1"
 (click)="addSet()">
<mat-icon>
add
</mat-icon>
</button>

<!-- Go to Next Set -->
<button *ngIf="!isReadOnly && partOfDraftTrip == -1"
 mat-fab
 class="bottom-toolbar-button"
 type="button"
 aria-label="Example icon button with a plus one icon"
 matTooltip="Next Set"
 matTooltipPosition="above"
 [disabled]="setIndex == -1"
 (click)="nextSet()">
<mat-icon>
arrow_forward
</mat-icon>
</button>
  </div>
 
<!-- Delivery Button -->
    <button *ngIf="!isReadOnly && partOfDraftTrip == -1"
            mat-fab
            class="blue-icon-button"
            matTooltip="Delivery"
            matTooltipPosition="below"
            (click)="navigateToDelivery()">
      <mat-icon>drive_folder_upload</mat-icon>
    </button>
</mat-toolbar>
